var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningOutlineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9772 1.75006C10.3559 0.658286 8.96706 0.276746 7.87497 0.898038C7.51953 1.10041 7.225 1.39462 7.02295 1.75006L1.03496 12.418C0.647939 13.0996 0.655673 13.9361 1.05494 14.6103C1.46032 15.306 2.20697 15.7314 3.01226 15.7246H14.9879C15.7929 15.7311 16.5399 15.306 16.9452 14.6103C17.3445 13.9358 17.3522 13.0993 16.9652 12.418L10.9772 1.75006ZM15.7584 13.9181C15.5973 14.1894 15.3034 14.3541 14.9879 14.3499H3.01226C2.69614 14.3538 2.40225 14.1885 2.24177 13.9162C2.08935 13.6629 2.08645 13.3471 2.23436 13.0912L8.2217 2.42259C8.50431 1.99271 9.0821 1.87348 9.51198 2.15641C9.618 2.22602 9.70855 2.31657 9.77816 2.42259L15.7658 13.0906C15.9137 13.3468 15.9108 13.6629 15.7584 13.9162V13.9181Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.27
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 4.72501C8.62027 4.72501 8.31253 5.03275 8.31253 5.41236L8.31257 9.97505C8.31257 10.3547 8.62031 10.6624 8.99992 10.6624C9.37953 10.6624 9.68727 10.3547 9.68727 9.97505L9.68723 5.41236C9.68723 5.03275 9.37948 4.72501 8.99988 4.72501Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.27
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99985 12.9749C9.37947 12.9749 9.6872 12.6671 9.6872 12.2875C9.6872 11.9079 9.37947 11.6002 8.99985 11.6002C8.62024 11.6002 8.3125 11.9079 8.3125 12.2875C8.3125 12.6671 8.62024 12.9749 8.99985 12.9749Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.27
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutlineIcon);
export default __webpack_public_path__ + "static/media/warning-outline-icon.a47398ce4cb359319293a77210b6c73f.svg";
export { ForwardRef as ReactComponent };